import { MemorizedEventEmitter } from './MemorizedEventEmitter';
import type { EventNamesBase } from './types';

export class LockableEventEmitter<
  EventNames extends EventNamesBase,
> extends MemorizedEventEmitter<EventNames> {
  readonly lockedEvents = new Map<EventNames, string>();

  /**
   * Unlocks an event if the given key matches key that locked the event.
   * @param eventName The name of the event to unlock
   * @param key
   * @returns
   */
  unlockEvent(eventName: EventNames, key: string): boolean {
    const lockedEventKey = this.lockedEvents.get(eventName);

    if (!this.isLockedEvent(eventName)) {
      return true;
    }

    if (key === lockedEventKey) {
      this.lockedEvents.delete(eventName);
      return true;
    }

    return false;
  }

  /**
   * Locks an event that which will prevent other events with the same event name from triggering.
   * If this event is already locked, it will not be locked again until it is unlocked.
   * @param eventName The name of the event to lock
   * @param key
   * @returns
   */
  lockEvent = (eventName: EventNames, key: string): void => {
    if (!this.lockedEvents.has(eventName)) {
      this.lockedEvents.set(eventName, key);
    }
  };

  isLockedEvent(eventName: EventNames): boolean {
    return this.lockedEvents.has(eventName);
  }

  emit(eventName: EventNames, arg?: unknown): boolean {
    if (!this.isLockedEvent(eventName)) {
      return super.emit(eventName, arg);
    }

    return false;
  }
}
